var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.786,14.667H29.266C29.053,12.52 28.319,10.52 27.213,8.8C24.906,9.907 23.226,12.067 22.786,14.667Z",
    fill: "#6ECA8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.213,14.667C8.773,12.067 7.093,9.907 4.787,8.8C3.68,10.52 2.947,12.52 2.733,14.667H9.213Z",
    fill: "#6ECA8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.093,14.666C20.52,11.213 22.6,8.28 25.506,6.666C23.373,4.493 20.52,3.053 17.333,2.733V14.666H20.093Z",
    fill: "#6ECA8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.906,14.666H14.667V2.733C11.48,3.053 8.613,4.493 6.493,6.666C9.4,8.28 11.48,11.213 11.906,14.666Z",
    fill: "#6ECA8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.093,17.333H17.333V29.267C20.52,28.947 23.386,27.507 25.506,25.333C22.6,23.72 20.52,20.787 20.093,17.333Z",
    fill: "#6ECA8A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.787,23.2C7.08,22.093 8.773,19.92 9.213,17.333H2.733C2.947,19.48 3.68,21.48 4.787,23.2Z",
    fill: "#6ECA8A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.786,17.333C23.226,19.933 24.906,22.093 27.213,23.2C28.319,21.48 29.053,19.48 29.266,17.333H22.786Z",
    fill: "#6ECA8A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.906,17.333C11.48,20.787 9.4,23.72 6.493,25.333C8.627,27.507 11.48,28.947 14.667,29.267V17.333H11.906Z",
    fill: "#6ECA8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.7e2c09ed12950ebab17c33218f0872e5.svg";
export { ForwardRef as ReactComponent };